import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import { Checkbox, Textfield, Dropdown } from '@workboard/wobo-ui';
import styled from 'styled-components';
import HelpTextComp from '../../../../helper/helptext.component';
import {getTargetValue} from '../../../../common/getTargetValue.component'
import { MIT_TYPE, isLegacyAddUpDecrease } from './mitConstants'
import { krdetailConstants } from '../../../../../constants/krdetails.constants'


const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -12px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledDropdown = styled(Dropdown)`
  min-width: 113px !important;
  max-width: fit-content;
  height: 39px !important;
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-select.Mui-disabled {
        .MuiListItemText-root{
            color: rgba(0, 0, 0, 0.87) !important;
        }
    }
    .MuiSelect-icon.Mui-disabled{
        display: none;
    }
  .MuiSelect-root {
    background-color: #f2f2f2 !important;
    border: 1px solid rgba(0,0,0,0.06);
    height: 38px;
  }
  #unit-measure-dropdown{
    min-width: 154px;
  }
  #result-value-dropdown{
    min-width: 220px;
  }
`;
const MIT_DS_METRICS = ["1", "2","8","9", 1, 2, 8, 9];

class OverallTarget extends Component {
    constructor(props) {
        super(props);
        const {t} = this.props;
        this.state = {
            initial_data: this.props.item && this.props.item.initial_data ? this.props.item.initial_data : this.props.basicInlineData && this.props.basicInlineData.initial_data ? this.props.basicInlineData.initial_data : 0,
            target: this.props.target || "",
            stretch: this.props.stretch || "",
            interval: this.props.item && this.props.item.interval ? this.props.item.interval : this.props.basicInlineData && this.props.basicInlineData.interval ? this.props.basicInlineData.interval : "",
            errors: this.props.errorsObject || this.props.errors || {},
            dsMetric: this.props.dsMetric != null
                ? this.props.dsMetric
                : this.props.item &&
                this.props.item.counting &&
                MIT_DS_METRICS.includes(this.props.item.counting)
                ? this.props.item.counting
                : 1,
            startValueErr: t("Add Value"),
            targetValueErr: t("Add Value"),
            stretchValueErr: this.props.stretchValueErr ?? '',
            lowerLimitErr: t("Add Value"),
            upperLimitErr: t("Add Value"),
            isStretchEnabled: this.props.isStretchEnabled
        };
    }

    targetClick = (e, id) => {
        this.setState({
            dsMetric: id,
            errors: {}
        }, () => {
            this.props.changeProgressType(id);
        });
    };

    componentDidUpdate(prevProps) {
        if (this.props.target !== prevProps.target) {
            this.setState({target: this.props.target});
        }

        if (this.props.stretch !== prevProps.stretch) {
            this.setState({stretch: this.props.stretch});
        }

        if (this.props.startValueErr !== prevProps.startValueErr) {
            this.setState({startValueErr: this.props.startValueErr});
        }

        if (this.props.stretchValueErr !== prevProps.stretchValueErr) {
            this.setState({stretchValueErr: this.props.stretchValueErr});
        }

        if (this.props.initial_data !== prevProps.initial_data) {
            this.setState({initial_data: this.props.initial_data});
        }

        // Sync direction when parent owns dsMetric (e.g. ADD_UP reset in MitPeople)
        if (
            this.props.dsMetric != null &&
            Number(this.props.dsMetric) !== Number(prevProps.dsMetric) &&
            Number(this.props.dsMetric) !== Number(this.state.dsMetric)
        ) {
            this.setState({ dsMetric: this.props.dsMetric });
        } else if (
            this.props.item &&
            this.props.item.counting != null &&
            MIT_DS_METRICS.includes(this.props.item.counting) &&
            Number(this.props.item.counting) !== Number(this.state.dsMetric) &&
            this.props.item.counting !== prevProps.item?.counting
        ) {
            this.setState({ dsMetric: this.props.item.counting });
        }
    }

    render() {
        const {t} = this.props;
        let basicMeasure = [
            { 
                value: 1,
                name : t("Count as number")
            },
            { 
                value: 2,
                name : t("Count as currency")
            },
            { 
                value: 3,
                name : t("Count as percentage")
            }
        ];
        let errors = this.props.errorsObject || this.props.errors;
        // MR-8337: hide Decrease-to under Add-up for new setups; keep legacy rows visible and editable
        const legacyAddUpDecrease = isLegacyAddUpDecrease(
          this.props.mitType,
          this.state.dsMetric,
        );
        const directionOptions =
          this.props.mitType === MIT_TYPE.ADD_UP && !legacyAddUpDecrease
            ? getTargetValue(true).filter((option) => option.value != krdetailConstants.METRIC_COUNTING_DOWN)
            : getTargetValue(true);
       
        return (
            <div>
                <div className={"basickrstarttargetHead basic-flex-box" + (this.state.isStretchEnabled ? " starttargetHeadStretchHeight" : " starttargetHeadHeight")} style={{alignItems: 'start'}}>
                    <div className= {!this.state.isStretchEnabled ? "basic-flex-content marginR12" : (typeof errors["showStartErr"] !== "undefined" && errors["showStartErr"] ? "basic-flex-content error-width-basic-mit" : "basic-flex-content")} style={{width : `${!this.state.isStretchEnabled ? '100px' : ''}`}}>
                        <div className="metrictargettext marginB5 marginNone" id="multipleKR-startValue">
                            {t('Starting from')} <span className="text-style-1">*</span>
                        </div>
                        <Textfield 
                            type="text" 
                            aria-labelledby="multipleKR-startValue"
                            name="initial_data" 
                            ref="initial_data" 
                            className={!this.state.isStretchEnabled ? "text-target-field kr-text-target-field text-target-width" : "text-target-field kr-text-target-field stretch-text-target-width"}
                            isError={typeof errors["showStartErr"] !== "undefined" && errors["showStartErr"]? true : false}
                            helperText={typeof errors["showStartErr"] !== "undefined" && errors["showStartErr"] ? this.state.startValueErr : null}
                            value={this.state.initial_data}
                            onChange={this.props.handleChange}
                            autoComplete="off"
                        />
                    </div>
                    <div className={!this.state.isStretchEnabled ? "basic-flex-content marginR12" : "basic-flex-content"}>
                        <div className="krs-target-value-text marginNone marginB5">
                            {t('Result value')}
                            <HelpTextComp>
                                <div className="targetHelp">
                                    <span className="dot inLineBlk"/>
                                    <span className="targetHelpDec inLineBlk">
                                        <strong>{t('Should increase to')} </strong>
                                        {t('example') + ': '}{t('Starting from 0 MQLs moving to 10 MQLs')}
                                    </span>
                                </div>
                                {(this.props.mitType !== MIT_TYPE.ADD_UP || legacyAddUpDecrease) && (
                                <div className="targetHelp">
                                    <span className="dot inLineBlk"/>
                                    <span className="targetHelpDec inLineBlk">
                                        <strong>{t('Should decrease to')} </strong>
                                        {t('example') + ': '}{t('Starting from 100 bugs moving to 10 bugs')}
                                    </span>
                                </div>
                                )}
                            </HelpTextComp>
                        </div>
                        <StyledDropdown
                            options={directionOptions}
                            onChange={(e) => { this.targetClick(e, e.target["value"]) }}
                            id={"result-value-dropdown"}
                            data-testid={"result-value-dropdown"}
                            value={Number(this.state.dsMetric)}
                            aria-label={t('Result Value')}
                            showStartNodeOnSelect
                            optionTitleProp="name"
                            optionValueProp="value"
                            disabled={!!this.props.mitChildKr}
                            MenuProps={{
                                style: { zIndex: '1500000' }
                            }}
                        />
                    </div>  
                    {this.state.dsMetric != 4 && (
                        <div className={ this.state.isStretchEnabled  ? "basic-flex-content marginT22 marginR3" : "basic-flex-content marginR12"}>
                            <div className={!this.state.isStretchEnabled  ? "metric-target-text marginB5" :"marginB5 stretch-target-text"} style={{width: 'auto'}} id="multipleKR-target">
                            {t('Target value')} <span className="text-style-1">*</span>
                            </div>
                            { this.state.isStretchEnabled && (
                                <div className="metric-target-text marginB5 widthFitContent">  
                                {t('Committed Target')} 
                                <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText  marginL3">
                                    {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.') + t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                                </HelpTextComp>
                                </div>
                            )}
                            <Textfield 
                                type="text" 
                                aria-labelledby="multipleKR-target"
                                name="target" 
                                ref="target" 
                                className={this.state.isStretchEnabled ? "text-target-field stretch-text-target-width" : "text-target-field kr-text-target-field text-target-width"}
                                isError={((typeof errors["showTargetErr"] !== "undefined" && errors["showTargetErr"]) || (typeof errors["showTargetHightlightErr"] !== "undefined" && errors["showTargetHightlightErr"]))}
                                helperText={typeof errors["showTargetErr"] !== "undefined" && errors["showTargetErr"] ? this.state.targetValueErr : null}
                                data-testid="metric-end-value"
                                value={this.state.target}
                                onChange={this.props.handleChange}
                                autoComplete="off"
                                placeholder={t('Enter Value')}
                            />
                        </div>
                    )
                }
                { this.state.isStretchEnabled && this.state.dsMetric != 4 && (
                        <div className="target-input-box" style={{marginTop: '1px'}}>
                            <div className="metric-target-text marginB5 widthFitContent">
                                {t('Stretch target')}
                                <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                                    {t('Aim for best possible! Your stretch target is what you aspire to achieve beyond what has been committed')}
                                </HelpTextComp>
                            </div>
                            <Textfield 
                                type="text" 
                                aria-labelledby="multipleKR-stretch"
                                name="stretch" 
                                ref="stretch" 
                                className="text-target-field stretch-text-target-width" 
                                isError={(typeof errors["showStretchErr"] !== "undefined" && errors["showStretchErr"]) || (typeof errors["showStretchHightlightErr"] !== "undefined" && errors["showStretchHightlightErr"])}
                                helperText={typeof errors["showStretchErr"] !== "undefined" && errors["showStretchErr"] ? this.state.stretchValueErr : null}
                                data-testid="metric-end-value"
                                value={this.state.stretch}
                                onChange={this.props.handleChange}
                                autoComplete="off"
                                placeholder={t('Enter Value')}
                            />
                        </div>
                    )
                }
                    <div className="basic-flex-content">
                        <div className="metric-count-text marginB5" style={{width: 'auto'}} id="unit-measure">
                            {t('Unit of measurement')} <span className="text-style-1">*</span>
                        </div>
                        <StyledDropdown
                            data-testid="myAlign"
                            id="unit-measure-dropdown"
                            aria-labelledby="unit-mesure"
                            value={Number(this.props.measureType)}
                            autoMenuWidth
                            onChange={(event) => {
                                this.props.mitPeopleCb(event.target["value"], false)
                            }}
                            optionTitleProp="name"
                            optionValueProp="value"
                            options={basicMeasure}
                            MenuProps={{
                                style: { zIndex: '1500000'},
                            }}
                        />
                    </div>
                    { !this.state.isStretchEnabled &&
                        <div className="basic-flex-content">
                            <div className="committedKRWrapper marginL0">
                                <StyledCheckbox
                                id="committedKR"
                                className="committedCheckBox"
                                isChecked={this.props.committedKRFlag == 1 ? true : false}
                                label={`${t('Committed result')}`}
                                onClick={this.props.handleCommittedKRChange}
                                />
                                <HelpTextComp wrapperClass="committedKRHelpText">
                                {`${t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} ${t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}`}
                                </HelpTextComp>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default withTranslation()(OverallTarget);
